import styled from 'styled-components';

import { Text } from '@gympass/yoga';

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  margin: auto;
`;

export const PaginationItem = styled(Text)<{
  disable: boolean;
}>`
  :nth-of-type(1) {
    font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
    margin-right: 5px;
  }

  :nth-of-type(2) {
    letter-spacing: 3px;
  }

  letter-spacing: 1.5px;
`;

export const NotesButton = styled.button`
  border: 0;
  background: none;
  outline: 0;
  height: 32px;
  cursor: pointer;
  padding: 0;
`;
